export default __webpack_public_path__ + "static/icon-spacing-light-62a240f1ed4160de339a16546a4c153e.png";